import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const Icon3dBoxTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"3d-box-top, shaders, model, cube, ar"} maskId="square-filled-radius-0-stroke-1-Icon3dBoxTop"><path d="M11.5 12.2881V22.5381L2.87305 17.5576L2.62305 17.4141V7.16211L11.5 12.2881Z" fill="currentColor"/><path d="M21.377 17.4141L21.127 17.5576L12.5 22.5381V12.2881L21.377 7.16211V17.4141Z" fill="currentColor"/><path d="M20.875 6.29688L11.999 11.4219L3.12305 6.29688L12 1.17285L20.875 6.29688Z" fill="currentColor"/></CentralIconBase>;
}));

export default Icon3dBoxTop;
